<template>
  <div class="cat-grid">
    <div v-if="_has_header" class="header">
      <slot name="header"></slot>
    </div>
    <div class="row">
      <div v-if="_has_left" :class="_left">
        <slot name="left"></slot>
      </div>
      <div :class="_content">
        <slot></slot>
      </div>
      <div v-if="_has_right" :class="_right">
        <slot name="right"></slot>
      </div>
    </div>
    <div v-if="_has_footer" class="_footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "CatGrid",
  computed: {
    _has_left: function () {
      return this.$slots.left;
    },
    _has_right: function () {
      return this.$slots.right;
    },
    _has_footer: function () {
      return this.$slots.footer;
    },
    _has_header: function () {
      return this.$slots.header;
    },
    _left: function () {
      return {
        column: true,
        "large-2": true
      };
    },
    _content: function () {
      var css = {
        column: true
      };
      if (!this._has_left && !this._has_right) {
        css["large-12"] = true;
      } else if (this._has_left && this._has_right) {
        css["large-8"] = true;
      } else {
        css["large-10"] = true;
      }
      return css;
    },
    _right: function () {
      return {
        column: true,
        "large-2": true
      };
    },
    _header: function () {
      return {
        header: this._has_header
      };
    },
    _footer: function () {
      return {
        footer: this._has_footer
      };
    }
  }
});
</script>
